import React, { Component } from 'react'
import Links from '../Link'

const styles = {
  notification: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#24AEF2',
    color: 'white',
    padding: '20px'
  },
  text: {
    fontSize: '12px',
    fontWeight: '700',
    WebkitFontSmoothing: 'antialiased',
    MozSmoothing: 'antialiased',
    padding: '0',
    margin: '0',
    letterSpacing: '2px',
    textTransform: 'uppercase'
  }
}

export class Notification extends Component {
  render () {
    return <div style={styles.notification}>{this.props.children}</div>
  }
}

export class StandardNotification extends Component {
  render () {
    return (
      <p style={styles.text}>
        We've sent a confirmation email to
        <Links.Link>zparekh@researchnow.com</Links.Link>
        <Links.LinkButton>Send another one</Links.LinkButton>
      </p>
    )
  }
}
